import React from 'react';

export const HideIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon">
      <svg id="icon-controls-toggle__on" viewBox="0 0 1024 1024">
        <title>Controls Toggle On</title>
        <path
          className="path1"
          d="M337.572 491.52c0-86.479 78.086-156.619 174.428-156.619s174.428 70.14 174.428 156.619c0 86.479-78.086 156.619-174.428 156.619s-174.428-70.14-174.428-156.619zM901.12 491.52c-74.736-121.958-220.975-245.76-389.12-245.76-168.141 0-314.384 123.802-389.12 245.76 74.736 121.958 220.979 245.76 389.12 245.76 168.145 0 314.384-123.802 389.12-245.76zM418.075 491.52c0 46.58 42.050 84.32 93.925 84.32s93.925-37.741 93.925-84.32c0-46.58-42.050-84.32-93.925-84.32s-93.925 37.741-93.925 84.32z"
        ></path>
      </svg>
    </svg>
  );
};
